export const BILLING_LABEL_KEYS = Object.freeze({
    cubicmeters: '§calc.step1.billing_options.cubicmeters',
    hours: '§calc.step1.billing_options.hours',
    kw: '§calc.step1.billing_options.kw',
    kwh: '§calc.step1.billing_options.kwh',
    other: '§calc.step1.billing_options.other',
    pallets: '§calc.step1.billing_options.pallets',
    picks: '§calc.step1.billing_options.picks',
    pieces: '§calc.step1.billing_options.pieces',
    runningmeters: '§calc.step1.billing_options.runningmeters',
    sheets: '§calc.step1.billing_options.sheets',
    squaremeters: '§calc.step1.billing_options.squaremeters',
    tons: '§calc.step1.billing_options.tons',
    washes: '§calc.step1.billing_options.washes',
})

export function getBillingLabelKey(code) {
    return BILLING_LABEL_KEYS[code] || BILLING_LABEL_KEYS.hours
}
